import React from "react"
// react component for creating dynamic tables
import ReactTable, {ReactTableDefaults} from "react-table"
import {connect} from 'react-redux'
import moment from "moment-timezone";
import { CSVLink } from "react-csv"
// @material-ui/core components
import withStyles from "@material-ui/core/styles/withStyles"
//import TextField from "@material-ui/core/TextField";
// @material-ui/icons
import Description from "@material-ui/icons/Description"
// core components
import GridContainer from "components/Grid/GridContainer.jsx"
import GridItem from "components/Grid/GridItem.jsx"
import Card from "components/Card/Card.jsx"
import CardBody from "components/Card/CardBody.jsx"
import CardIcon from "components/Card/CardIcon.jsx"
import CardHeader from "components/Card/CardHeader.jsx"
import LinearProgress from '@material-ui/core/LinearProgress';

import FormControl from "@material-ui/core/FormControl";
import InputLabel from '@material-ui/core/InputLabel';
import Select from '@material-ui/core/Select';
import MenuItem from '@material-ui/core/MenuItem';
import FormControlLabel from "@material-ui/core/FormControlLabel";
import Checkbox from "@material-ui/core/Checkbox";
import Datetime from "react-datetime";
import {sum} from 'lodash'

import { cardTitle } from "assets/jss/material-dashboard-pro-react.jsx"

import {
  accountStatementFetch,
  accountStatementFetched,
  accountStatementCsv
} from 'actions/ibReports'
import {
  profileFilter,
  profilesAvailableFetch
} from 'actions/profiles'
import {
  ibTreeAvalableFetch
} from 'actions/ibTrees'
import selectStyles from "assets/jss/material-dashboard-pro-react/customSelectStyle";
import extendedFormsStyle from "assets/jss/material-dashboard-pro-react/views/extendedFormsStyle.jsx";
import Button from "components/CustomButtons/Button.jsx";

const styles = {
  cardIconTitle: {
    ...cardTitle,
    marginTop: "15px",
    marginBottom: "0px"
  },
  datepickerLabel: {
    top: '-20px',
    left: '0',
    position: 'absolute',
    color: 'rgba(0, 0, 0, 0.26) !important',
    padding: '0',
    fontSize: '14px',
    fontWeight: '400',
    //textTransform: 'uppercase',
    lineHeight: '1'
  },
  datepickerText: {
    fontSize: '14px !important',
    paddingTop: '10px !important',
  },
  tableCell: {
    width: '120px',
  },
  cellRight: {
    textAlign: 'right'
  },
  line: {
    borderTop: '2px solid transparent',
    width: '90%',
    position: 'absolute',
    bottom: '-15px'
  }
};

class List extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      from: moment.tz(moment(new Date()).format('YYYY-MM-DD') + ' 5:00 PM', 'YYYY-MM-DD h:mm A', 'America/New_York').subtract(2,'day').format(),
      to: moment.tz(moment(new Date()).format('YYYY-MM-DD') + ' 5:00 PM', 'YYYY-MM-DD h:mm A', 'America/New_York').subtract(1,'day').format(),
      includeChildren: true,
      showIncludeChildren: true,
      paymentTypes: ['All', 'Rebates', 'Withdrawal', 'Adjustment'],
      paymentType: 'Rebates',
      csv: ''
    }
  }
  csvLink = React.createRef()

  handleChange(e, filter){
    let state = this.state
    let value = filter === 'from' || filter === 'to' ? e : e.target.value
    if(filter === 'includeChildren'){
      value = !this.state.includeChildren
    }

    state[filter] = value
    this.setState({...state})
    
  }
  fetchReport(){
    const{from, to, includeChildren, paymentType} = this.state
    console.log('Date.parse(from) Date.parse(to)', from,to)

    let fromFormat = moment.tz(moment(from).format('YYYY-MM-DD') + ' 5:00 PM', 'YYYY-MM-DD h:mm A', 'America/New_York').subtract(1,'day').format();
    let toFormat = moment.tz(moment(to).format('YYYY-MM-DD') + ' 5:00 PM', 'YYYY-MM-DD h:mm A', 'America/New_York').format();
    
    const params = {
      from: Date.parse(fromFormat),
      to: Date.parse(toFormat),
      includeChildren:includeChildren,
      paymentTypes:paymentType
    }

    this.props.fetch(params);
  }
  componentDidMount(){
    this.props.profileFilter({size: 10000})
    this.props.profilesFetch().then((e) => {
      //let fromDate = moment(new Date()).subtract(1,'day').valueOf()
      //let toDate = moment(new Date()).endOf('day').valueOf()
      let fromDate = moment.tz(moment(new Date()).format('YYYY-MM-DD') + ' 5:00 PM', 'YYYY-MM-DD h:mm A', 'America/New_York').subtract(2,'day').valueOf()
      let toDate = moment.tz(moment(new Date()).format('YYYY-MM-DD') + ' 5:00 PM', 'YYYY-MM-DD h:mm A', 'America/New_York').valueOf()
      
      //let profile = e.content && e.content.length !== 0 ? e.content[0].profileId : 0
      let includeChildren = true
      let paymentType = this.state.paymentType;
      let params = {
        'from': fromDate,
        'to': toDate,
        'includeChildren' : includeChildren,
        'paymentTypes': paymentType
      };
      this.props.fetch(params);
      
    })
  }

  ValidDate( current ){
      let minDate = moment('2019-07-22 00:00:00');
      
      return current >= minDate;
  }

  exportCsv(){
    const{from, to, includeChildren, paymentType} = this.state

    let fromFormat = moment.tz(moment(from).format('YYYY-MM-DD') + ' 5:00 PM', 'YYYY-MM-DD h:mm A', 'America/New_York').subtract(1,'day').format();
    let toFormat = moment.tz(moment(to).format('YYYY-MM-DD') + ' 5:00 PM', 'YYYY-MM-DD h:mm A', 'America/New_York').format();
    
    const params = {
      from: Date.parse(fromFormat),
      to: Date.parse(toFormat),
      includeChildren: includeChildren,
      paymentTypes: paymentType
    }
   
    this.props.accountStatementCsv(params).then((e) => {
      this.setState({csv: e},() => this.csvLink.current.link.click())
    })
  }
  renderFilters(){
    const {classes} = this.props
    const {paymentTypes,paymentType} = this.state
    
    const fromDate = this.state.from
      ? moment(this.state.from).startOf('day').format('YYYY-MM-DD')
      : ''

    const toDate = this.state.to
      ? moment(this.state.to).endOf('day').format('YYYY-MM-DD')
      : ''

    // const tomorrow = moment.utc(new Date()).add(1,'days').endOf('day')
    // const valid = (current) => {
    //   return current.isBefore(tomorrow)
    // }
    
    return (
      <GridContainer style={{marginBottom: '30px'}}>
        <GridItem xs={2}>
          <FormControl
            fullWidth
            className={classes.selectFormControl}
          >
            <InputLabel htmlFor="paymentType" className={classes.selectLabel} >
              Payment Type
            </InputLabel>
            <Select
              value={paymentType}
              MenuProps={{
                className: classes.selectMenu
              }}
              classes={{
                select: classes.select
              }}
              inputProps={{
                onChange: (event) => this.handleChange(event, "paymentType"),
                id: "paymentType",
                name: "paymentType"
              }}>
              {paymentTypes
                .map((e) => (
                  <MenuItem
                    key={e}
                    classes={{
                      root: classes.selectMenuItem
                    }}
                    value={e}>
                    {e}
                  </MenuItem>
                ))}
            </Select>
          </FormControl>
          
        </GridItem>
      
        <GridItem xs={3}>
            
            <FormControl className={classes.selectFormControl} style={{paddingTop: '5px'}} fullWidth>
              <InputLabel className={classes.datepickerLabel}>Start Date *</InputLabel>
            
              <Datetime
                timeFormat={false}
                dateFormat={'YYYY-MM-DD'}
                inputProps={{placeholder: 'yyyy/mm/dd'}}
                utc={true}
                isValidDate={ this.ValidDate }
                locale={moment.locale('en',{week: {
                  dow: 1
                }})}
                //isValidDate={valid}
                onChange={(event) => this.handleChange(event, "from")}
                value={fromDate}
                className={classes.select + ' ' + classes.datepickerText}
              />
            </FormControl>
        </GridItem>

        <GridItem xs={3}>
          <FormControl className={classes.selectFormControl} style={{paddingTop: '5px'}} fullWidth>
              <InputLabel className={classes.datepickerLabel}>To Date *</InputLabel>
              <Datetime
                id="from"
                name="to"
                props={{
                  name:"to"
                }}
                dateFormat={'YYYY-MM-DD'}
                isValidDate={ this.ValidDate }
                timeFormat={false}
                inputProps={{
                  id:"to",
                  name:"to",
                  readOnly:true,
                  placeholder: 'yyyy/mm/dd'
                }}
                onChange={(event) => this.handleChange(event, "to")}
                utc={true}
                locale={moment.locale('en',{week: {
                  dow: 1
                }})}
                value={toDate}
                className={classes.select + ' ' + classes.datepickerText}
              />

          </FormControl>
        </GridItem>
        {/*this.state.showIncludeChildren && (*/
          <GridItem xs={2}>
            <FormControlLabel
              style={{marginTop:'15px'}}
              control={
                <Checkbox
                  color="default"
                  checked={this.state.includeChildren}
                  onChange={(event) => this.handleChange(event, "includeChildren")}
                />
              }
              classes={{
                label: classes.linkFooter
              }}
              label="Including SubIBs"
            />
          </GridItem>
        /*)*/}
        <GridItem xs={2}>
          <div style={{float:'right'}}>
            <Button onClick={() => this.fetchReport()} className={classes.submit} color="success">Search</Button>
          </div>
        </GridItem>
        
        
      </GridContainer>
    )
  }
  setPageSizeOptions(data){
    const pageSizeOptions = [10]
    if(data.length > 10) {
      pageSizeOptions.push(20)
    }
    if(data.length > 20) {
      pageSizeOptions.push(50)
    }
    if(data.length > 50) {
      pageSizeOptions.push(100)
    }

    Object.assign(ReactTableDefaults, {
      pageSizeOptions: pageSizeOptions,
    })
    return pageSizeOptions
  }
  render() {
    const { classes, report,report:{data}, report:{additionalData} ,reports} = this.props
    this.setPageSizeOptions(data)
    
    return (
      <GridContainer>
        <GridItem xs={12}>
          <Card>
            <CardHeader color="primary" icon>
              <CardIcon color="primary">
                <Description />
              </CardIcon>
              <h4 className={classes.cardIconTitle}>My Reports</h4>
            </CardHeader>
            <CardBody>
              {this.renderFilters()}
              {(reports.isFetching) ?
              (<LinearProgress color="primary"/>)
              :
              (<div>
              { ((accountStatementFetched) && (report.data.length>0)) &&
              <GridContainer style={{marginBottom: '0px'}}>
                <GridItem xs={12}>
                
                  <strong style={{float:'right',marginRight:'5px'}}>Opening Balance : { parseFloat(additionalData.opening_balance).toFixed(2).replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1,") }</strong>
                
                </GridItem>
              </GridContainer>
              }
              <ReactTable style={{borderTop:'1px solid #D1D1D1',marginTop:'10px'}}
                data={data}
                // onPageSizeChange={(pageSize, pageIndex) => {
                //   console.log(pageSize)
                // }}
                columns={[
                  {
                    id: '0',
                    sortable: true,
                    Header: () => <div><span>{'Date'}</span><hr className={classes.line} /></div>,
                    width: 120,
                    headerStyle: {
                      whiteSpace: 'unset'
                    },
                    headerClassName: 'customHeader',
                    accessor: d => d[0]
                    ,
                    Footer: (
                      <span></span>
                    )
                  },
                  {
                    id: '4',
                    Header: () => <div className={classes.tableCell}><span>{'Clients Volume (USD)'}</span><hr className={classes.line} /></div>,
                    headerStyle: {
                      whiteSpace: 'unset'
                    },
                    //className: classes.cellRight,
                    width: 120,
                    headerClassName: 'customHeader',
                    accessor: d => ((!isNaN(d[4]) && (d[4]!==''))? (Math.round(d[4] * 100) / 100).toLocaleString() : '' ),
                    Footer: (
                      data.length !== 0 ? <span>{(Math.round(sum(data.map((row) => Number(row[4]))) * 100) / 100).toLocaleString()}</span> : ''
                    )
                  },
                  {
                    id: '3',
                    sortable: true,
                    Header: () => <div><span>{'Payment Type'}</span><hr className={classes.line} /></div>,
                    width: 120,
                    headerStyle: {
                      whiteSpace: 'unset'
                    },
                    headerClassName: 'customHeader',
                    accessor: d => d[3]
                    ,
                    Footer: (
                      <span></span>
                    )
                  },
                  {
                    id: '6',
                    sortable: true,
                    Header: () => <div><span>{'Destination'}</span><hr className={classes.line} /></div>,
                    width: 120,
                    headerStyle: {
                      whiteSpace: 'unset'
                    },
                    headerClassName: 'customHeader',
                    accessor: d => d[6]
                    ,
                    Footer: (
                      <span></span>
                    )
                  },
                  {
                    id: '8',
                    sortable: true,
                    Header: () => <div><span>{'Note Reason'}</span><hr className={classes.line} /></div>,
                    width: 120,
                    headerStyle: {
                      whiteSpace: 'unset'
                    },
                    headerClassName: 'customHeader',
                    accessor: d => d[8]
                    ,
                    Footer: (
                      <span></span>
                    )
                  },
                  {
                    id: '9',
                    sortable: true,
                    Header: () => <div><span>{'Amount of Rebates'}</span><hr className={classes.line} /></div>,
                    width: 120,
                    headerStyle: {
                      whiteSpace: 'unset'
                    },
                    headerClassName: 'customHeader',
                    accessor: d => d[9]
                    ,
                    Footer: (
                      <span></span>
                    )
                  },
                  {
                    id: '11',
                    sortable: true,
                    Header: () => <div><span>{'Currency'}</span><hr className={classes.line} /></div>,
                    width: 120,
                    headerStyle: {
                      whiteSpace: 'unset'
                    },
                    headerClassName: 'customHeader',
                    accessor: d => d[11]
                    ,
                    Footer: (
                      <span><strong>Total (USD)</strong></span>
                    )
                  },
                  {
                    id: '12',
                    Header: () => <div className={classes.tableCell}><span>{'Amount (USD)'}</span><hr className={classes.line} /></div>,
                    width: 120,
                    headerStyle: {
                      whiteSpace: 'unset'
                    },
                    //className: classes.cellRight,
                    headerClassName: 'customHeader',
                    accessor: d => (Math.round(d[12] * 100) / 100).toLocaleString(),
                    Footer: (
                      data.length !== 0 ? <span>{(Math.round(sum(data.map((row) => Number(row[12]))) * 100) / 100).toLocaleString()}</span> : ''
                    )
                  }
                ]}
                defaultPageSize={10}
                // showPaginationTop
                // showPaginationBottom={false}
                className="-striped -highlight"
              />
              
              <div style={{float:'left', marginTop: '20px', width:'50%'}}>
                <span>* Trading day starts at 5pm New York timezone.</span>
              </div>
              { ((accountStatementFetched) && (report.data.length>0)) &&

              <div style={{float:'right', marginTop: '20px',textAlign: 'right', width:'50%'}}>
                <p><strong>Rebates (USD) : { parseFloat(additionalData.rebates).toFixed(2).replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1,") }</strong></p>
                <p><strong>Withdrawals (USD) : { parseFloat(additionalData.withdrawals).toFixed(2).replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1,") }</strong></p>
                <p><strong>Adjustments (USD) : { parseFloat(additionalData.adjustments).toFixed(2).replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1,") }</strong></p>
                <p><strong>Closing Balance (USD) : { parseFloat(additionalData.closing_balance).toFixed(2).replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1,") }</strong></p>
              </div>

              }
              </div>)}
            </CardBody>
          </Card>
        </GridItem>
        {<GridItem xs={12}>
          <div style={{float:'right'}}>
            <Button onClick={() => this.exportCsv()} className={classes.submit} color="success">Export CSV</Button>
            <CSVLink data={this.state.csv} filename={"account-statement-report.csv"} ref={this.csvLink} className="hidden" />
          </div>
        </GridItem>}
      </GridContainer>
    );
  }
}

const mapStateToProps = (state) => ({
  report: state.ibReports.accountStatement,
  reports: state.ibReports,
  profiles: state.profiles.list
})

const mapDispatchToProps = (dispatch) => ({
  //fetch: (params) => dispatch(tradingAccountsFetch(params)),
  fetch: (params) => dispatch(accountStatementFetch(params)),
  accountStatementCsv: (params) => dispatch(accountStatementCsv(params)),
  profilesFetch: () => dispatch(profilesAvailableFetch()),
  profileFilter: (filter) => dispatch(profileFilter(filter)),
  ibTreeAvalableFetch: (data) => dispatch(ibTreeAvalableFetch(data))
})

export default withStyles({...styles, ...selectStyles, ...extendedFormsStyle})(connect(mapStateToProps, mapDispatchToProps)(List));



// WEBPACK FOOTER //
// ./src/views/AccountStatementReport/List.jsx